module.exports = __webpack_public_path__ + "fonts/typicons.95aa28e29618c068e8a53f64c87cb6a9.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/typicons.woff
// module id = 405
// module chunks = 0